const strengths = [
  { icon: "ri-lock-line", text: "秘密厳守" },
  { icon: "ri-money-cny-circle-line", text: "見積無料" },
  { icon: "ri-shield-check-line", text: "消臭・除菌対応" },
  { icon: "ri-map-pin-line", text: "京都府全域対応" },
];

export default function ServiceHero() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Clean%20and%20tidy%20Japanese%20apartment%20room%20in%20Kyoto%20after%20professional%20hoarding%20cleanup%20freshly%20cleaned%20wooden%20floor%20and%20organized%20storage%20boxes%20neatly%20arranged%20bright%20natural%20daylight%20through%20a%20large%20window%20a%20few%20remaining%20boxes%20of%20sorted%20belongings%20in%20the%20center%20right%20no%20people%20visible%20fresh%20sanitary%20reassuring%20atmosphere%20warm%20neutral%20beige%20and%20white%20tones%20editorial%20documentary%20photography%20simple%20clean%20background%20high%20detail%20photorealistic%20composition&width=1600&height=900&seq=gomi-yashiki-hero-v01&orientation=landscape"
          alt="京都のゴミ屋敷清掃後の様子。きれいに片付いた室内と整然と並べられた仕分け済みの段ボール"
          fetchPriority="high"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 z-[1] bg-gradient-to-b from-white/80 via-white/50 to-transparent md:bg-gradient-to-r md:from-white/80 md:via-white/50 md:to-transparent"></div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 md:px-8 pt-28 md:pt-36 pb-16 md:pb-20">
        <nav
          aria-label="パンくずリスト"
          className="mb-6 text-xs md:text-sm text-foreground-500"
        >
          <a
            href="/"
            className="hover:text-primary-600 cursor-pointer transition-colors"
          >
            ホーム
          </a>
          <span className="mx-2 text-foreground-300">&gt;</span>
          <span className="text-foreground-700 font-medium">ゴミ屋敷清掃</span>
        </nav>

        <p className="font-mincho text-accent-800 text-base md:text-lg tracking-[0.15em] mb-4 md:mb-5">
          京都のゴミ屋敷清掃・ゴミ屋敷片付け
        </p>

        <h1 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-foreground-950 leading-[1.5] tracking-wide">
          京都のゴミ屋敷清掃・
          <span className="text-primary-600">ゴミ屋敷片付け</span>
        </h1>

        <p className="mt-5 md:mt-6 text-sm md:text-base text-foreground-700 leading-[1.9] max-w-2xl">
          京都のゴミ屋敷清掃・ゴミ屋敷片付けは、経験豊富なスタッフが堆積したゴミを一気に片付けます。
          <br className="hidden md:block" />
          搬出・消臭・除菌・害虫駆除まで対応。プライバシー厳守・近隣配慮・見積無料。京都市内を中心に京都府全域へ伺います。
        </p>

        <div className="mt-7 md:mt-9 flex flex-col sm:flex-row gap-3">
          <a
            href="tel:0120024747"
            className="inline-flex items-center justify-center gap-2.5 px-6 py-4 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-bold text-sm md:text-base whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-phone-fill text-lg md:text-xl"></i>
            電話で無料相談
          </a>
          <a
            href="https://lin.ee/xf3zQex"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2.5 px-6 py-4 rounded-md bg-accent-700 hover:bg-accent-800 text-background-50 font-bold text-sm md:text-base whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-line-fill text-lg md:text-xl"></i>
            LINEで写真見積り
          </a>
        </div>

        <div className="mt-8 md:mt-10 flex flex-wrap gap-3">
          {strengths.map((s) => (
            <div
              key={s.text}
              className="flex items-center gap-2 px-3.5 py-2 rounded-full bg-background-50 border border-background-200"
            >
              <i className={`${s.icon} text-primary-600 text-sm`}></i>
              <span className="text-xs font-bold text-foreground-800 whitespace-nowrap">
                {s.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}